import apiLink from "../api/apiLink";
import { toast } from "react-toastify";

// import { hideModal } from "./actions/managerHandle";
import { FetchAreaSuccess, getSubareas } from "./areaSlice";
import {
  addCollectorSuccess,
  deleteCollectorSuccess,
  editCollectorSuccess,
  getCollectorBills,
  getCollectorSuccess,
} from "./collectorSlice";
import {
  addCustomerSuccess,
  addStaticCustomerSuccess,
  deleteCustomerSuccess,
  deleteStaticCustomerSuccess,
  editCustomerSuccess,
  editStaticCustomerSuccess,
  getCustomerConnectionFeeDue,
  getCustomerSuccess,
  getStaticCustomerActiveSuccess,
  getStaticCustomerSuccess,
  updateBalance,
  updateBalanceStaticCustomer,
} from "./customerSlice";

import { updateProfile } from "./authSlice";
import {
  getAllBillsSuccess,
  getDepositSuccess,
  getmyDepositSucces,
  getTotalBalanceSuccess,
  updateDepositSuccess,
  addDepositSucces,
  postWithdrawBalance,
  getWithdrawBalance,
} from "./paymentSlice";
import { getChartSuccess } from "./chartsSlice";
import { getMikrotikSuccess, getpppoePackageSuccess } from "./mikrotikSlice";
import { getAllRechargeHistory } from "./rechargeSlice";
import {
  createBandwidthBillReportSuccess,
  createBandwidthPackageSuccess,
  createBandwidthResellerSuccess,
  createBandwidthSaleInvoiceSuccess,
  createResellerSupportNumbersSuccess,
  deleteBandwidthPackageSuccess,
  deleteBandwidthResellerSuccess,
  deleteResellerSupportNumbersSuccess,
  getAllMikrotikPakages,
  getBandwidthBillReportSuccess,
  getBandwidthPackageSuccess,
  getBandwidthResellerSuccess,
  getBandwidthSaleInvoiceSuccess,
  getResellerSupportNumbersSuccess,
  getResellerUsersData,
  updatedBandwidthPackageSuccess,
  updatedBandwidthResellerSuccess,
  updatedBandwidthSaleInvoiceSuccess,
  updatedResellerSupportNumbersSuccess,
} from "./resellerSlice";
import {
  addResellerSupport,
  getResellerSupport,
  updateResellerSupport,
} from "./resellerSupportSlice";
import { getResellerProfileSuccess } from "./resellerProfileSlice";
import {
  getResellerChangePackageRequest,
  updateResellerChangePackageRequest,
} from "./netFeeSupportSlice";
import { BASE_URL_NF1, BASE_URL_NF2 } from "../api/baseURL";
import {
  getActiveCustomerSuccess,
  getExpiredCustomerSuccess,
  getInactiveCustomerSuccess,
  getPaidCustomerSuccess,
  getUnpaidCustomerSuccess,
} from "./dashboardInformationSlice";

const netFeeLang = localStorage.getItem("netFee:lang");
const langMessage = (color, bangla, english) => {
  // Notification for english language
  if (netFeeLang === "bn") {
    if (color === "success") {
      return toast.success(bangla);
    } else {
      return toast.error(bangla);
    }
  }

  // Notification for Bangla language
  if (netFeeLang === "en") {
    if (color === "success") {
      return toast.success(english);
    } else {
      return toast.error(english);
    }
  }
};

export const getCharts = async (dispatch, resellerId, Year, Month, User) => {
  try {
    let link = `/dashboard/${resellerId}?year=${Year}&month=${Month}`;
    if (User)
      link = `/dashboard/${resellerId}?year=${Year}&month=${Month}&user=${User}`;
    const res = await apiLink(link);
    dispatch(getChartSuccess(res.data));
  } catch (err) {
    console.log("Charts error: ", err);
  }
};

//Areas

// export const getArea = async (dispatch, resellerId) => {
//   try {
//     const res = await apiLink.get(`/reseller/area/${resellerId}`);
//     dispatch(FetchAreaSuccess(res.data));
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// Collector
export const getCollector = async (dispatch, resellerId) => {
  try {
    const res = await apiLink.get(`/reseller/collector/${resellerId}`);
    dispatch(getCollectorSuccess(res.data));
  } catch (error) {
    toast.error(error.response?.data.message);
  }
};

export const addCollector = async (dispatch, data, setIsLoading, setShow) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(`reseller/collector/${data.reseller}`, data);
    dispatch(addCollectorSuccess(res.data));
    setShow(false);
    langMessage(
      "success",
      "কালেক্টর সংযুক্ত সফল হয়েছে!",
      "Collector Added Successfully",
    );
  } catch (err) {
    if (err.response) {
      toast.error(err.response.data.message);
    }
  }
  setIsLoading(false);
};

export const editCollector = async (dispatch, data, setIsLoading, setShow) => {
  const { resellerId, collectorId, ...rest } = data;
  setIsLoading(true);
  try {
    const res = await apiLink.patch(
      `reseller/collector/${resellerId}/${collectorId}`,
      rest,
    );
    dispatch(editCollectorSuccess(res.data));

    setShow(false);
    langMessage(
      "success",
      "কালেক্টর এডিট সফল হয়েছে!",
      "Collector Updated Successfully!",
    );
  } catch (err) {
    if (err.response) {
      toast.error(err.response.data.message);
    }
  }
  setIsLoading(false);
};

export const deleteCollector = async (dispatch, ids, setIsDeleting) => {
  setIsDeleting(true);
  try {
    await apiLink.delete(
      `reseller/collector/${ids.resellerId}/${ids.collectorId}`,
    );
    dispatch(deleteCollectorSuccess(ids.collectorId));
    setIsDeleting(false);
    langMessage(
      "success",
      "কালেক্টর ডিলিট সফল হয়েছে!",
      "Collector Deleted Successfully!",
    );
  } catch (err) {
    if (err.response) {
      setIsDeleting(false);
      toast.error(err.response.data.message);
    }
  }
};

//Customers
export const getCustomer = async (dispatch, reseller, setIsloading) => {
  setIsloading(true);
  try {
    const res = await BASE_URL_NF1.get(`/reseller/customer/${reseller}`);
    dispatch(getCustomerSuccess(res.data));
    setIsloading(false);
  } catch (error) {
    console.log(error.message);
    setIsloading(false);
  }
};

export const addCustomer = async (
  dispatch,
  data,
  setIsloading,
  resetForm,
  setShow,
) => {
  setIsloading(true);
  try {
    const res = await apiLink.post("/reseller/customer", data);
    dispatch(addCustomerSuccess(res.data));
    langMessage(
      "success",
      "কাস্টমার সংযুক্ত সফল হয়েছে!",
      "Customer Added Successfully",
    );
    setShow(false);
    resetForm();
  } catch (error) {
    toast.error(error.message);
  }
  setIsloading(false);
};

export const editCustomer = async (
  dispatch,
  data,
  setIsloading,
  setShow,
  status,
) => {
  setIsloading(true);
  const { singleCustomerID, reseller, ...sendingData } = data;
  try {
    const res = await apiLink.patch(
      `/reseller/customer/${reseller}/${singleCustomerID}`,
      sendingData,
    );
    dispatch(editCustomerSuccess(res.data));

    if (status === "auto") {
      langMessage(
        "success",
        "কাস্টমার আটো ডিজেবল আপডেট সফল হয়েছে",
        "Customer Auto Disable Updated Successfully",
      );
    } else if (status === "status") {
      langMessage(
        "success",
        "কাস্টমার স্টাটাস আপডেট সফল হয়েছে",
        "Customer Status Updated Successfully",
      );
    } else {
      langMessage(
        "success",
        "কাস্টমার এডিট সফল হয়েছে",
        "Customer Updated Successfully",
      );
    }
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsloading(false);
};

export const deleteResellerCustomer = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    await BASE_URL_NF1.delete(
      `/reseller/customer/${data.reseller}/${data.customerID}?removeFromMikrotik=${data.mikrotik}`,
    );
    // delete customer from owner
    if (data.userType === "pppoe") {
      dispatch(deleteCustomerSuccess(data.customerID));
    } else {
      dispatch(deleteStaticCustomerSuccess(data.customerID));
    }

    setShow(false);
    langMessage(
      "success",
      "কাস্টমার ডিলিট সফল হয়েছে!",
      "Customer Deleted Successfully",
    );
  } catch (err) {
    if (err.response) {
      toast.error(err.response.data.message);
    }
  }
  setIsLoading(false);
};

// add reseller customer
export const addResellerStaticCustomer = async (
  dispatch,
  data,
  setIsloading,
  resetForm,
  setShow,
) => {
  setIsloading(true);
  try {
    const res = await apiLink.post("reseller/create-static-customer/", data);
    dispatch(addStaticCustomerSuccess(res.data.customer));
    setShow(false);
    langMessage(
      "success",
      "কাস্টমার এড সফল হয়েছে",
      "Customer Added Successfully",
    );

    resetForm();
  } catch (error) {
    toast.error(error.message);
  }
  setIsloading(false);
};

// edit reseller customer
export const updateResellerStaticCustomer = async (
  customerId,
  resellerId,
  dispatch,
  data,
  setIsloading,
  status,
  setShow,
) => {
  setIsloading(true);
  try {
    const res = await apiLink.patch(
      `reseller/update-static-customer/${resellerId}/${customerId}`,
      data,
    );
    dispatch(editStaticCustomerSuccess(res.data.customer));

    if (status === "auto") {
      langMessage(
        "success",
        "কাস্টমার আটো ডিজেবল আপডেট সফল হয়েছে",
        "Customer Auto Disable Updated Successfully",
      );
    } else if (status === "status") {
      langMessage(
        "success",
        "কাস্টমার স্টাটাস আপডেট সফল হয়েছে",
        "Customer Status Updated Successfully",
      );
    } else {
      langMessage(
        "success",
        "কাস্টমার এডিট সফল হয়েছে",
        "Customer Updated Successfully",
      );
    }

    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsloading(false);
};

//Static Customers
export const getStaticActiveCustomer = async (
  dispatch,
  ispOwnerId,
  resellerId,
  mikrotikId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF1.get(
      `/reseller/active/static/${ispOwnerId}/${resellerId}/${mikrotikId}`,
    );
    dispatch(getStaticCustomerActiveSuccess(res.data));
  } catch (error) {
    console.log(error.response.data.message);
  }
  setIsLoading(false);
};

//password update
export const passwordUpdate = async (data, setIsLoadingpass) => {
  setIsLoadingpass(true);

  try {
    await apiLink.post(`/auth/update-password`, data);
    setIsLoadingpass(false);
    langMessage(
      "success",
      "পাসওয়ার্ড আপডেট সফল হয়েছে!",
      "Password Updated Successfully",
    );
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoadingpass(false);
};

export const profileUpdate = async (dispatch, data, id, setIsLoading) => {
  setIsLoading(true);

  try {
    const res = await apiLink.patch(`/reseller/${id}`, data);
    // console.log(res.data);
    dispatch(updateProfile(res.data));
    setIsLoading(false);
    langMessage(
      "success",
      "প্রোফাইল আপডেট সফল হয়েছে!",
      "Profile Updated Successfully",
    );
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

//get reseller info
export const getResellerProfile = async (
  resellerId,
  dispatch,
  setCollectorResellerInfo,
) => {
  try {
    const res = await apiLink.get(`/reseller/${resellerId}`);
    dispatch(getResellerProfileSuccess(res.data));
  } catch (error) {
    console.log(error);
  }
};

// get reseller package rate
export const getResellerPackageRate = async (
  resellerId,
  packageId,
  setPackageRate,
) => {
  try {
    const res = await apiLink.get(
      `/reseller/package/rate/${resellerId}/${packageId}`,
    );
    setPackageRate(res.data);
  } catch (error) {
    toast.error(error.response?.data.message);
  }
};

//Bill
export const billCollect = async (
  dispatch,
  billData,
  paidConnectionFee,
  setLoading,
  resetForm,
  setResponseData,
  setTest,
  status,
  setShow,
) => {
  setLoading(true);
  try {
    const res = await apiLink.post("/reseller/monthlyBill", billData);

    if (status === "pppoe") {
      dispatch(updateBalance(res.data));
    } else if (status === "static") {
      dispatch(updateBalanceStaticCustomer(res.data));
    }

    // customer profile connection fee update after bill collect
    if (res.data.billType === "connectionFee") {
      const connectionFeeDue = paidConnectionFee + res.data.amount;
      dispatch(getCustomerConnectionFeeDue(connectionFeeDue));
    }

    setResponseData(res.data);
    setTest(true);
    langMessage(
      "success",
      "রিচার্জ সফল হয়েছে",
      "Bill Acceptance is Successful.",
    );

    setShow(false);
    resetForm();
  } catch (error) {
    toast.error(error.message);
  }
  setLoading(false);
};

export const addDeposit = async (dispatch, data, setLoading) => {
  setLoading(true);

  try {
    const res = await apiLink.post(`/deposit`, data);
    dispatch(addDepositSucces(res.data));
    langMessage(
      "success",
      "ডিপোজিট প্রদান সফল হয়েছে!",
      "Deposit Payment Successfully",
    );
  } catch (error) {
    toast.error(error.message);
  }
  setLoading(false);
};

//balance

export const getTotalbal = async (dispatch, setLoading) => {
  setLoading(true);
  try {
    const res = await apiLink.get(`bill/monthlyBill/balance`);
    dispatch(getTotalBalanceSuccess(res.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.message);
  }
  setLoading(false);
};

export const getDeposit = async (dispatch, setResellerPageLoader) => {
  setResellerPageLoader(true);
  try {
    const res = await apiLink.get(`/deposit`);
    dispatch(getmyDepositSucces(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setResellerPageLoader(false);
};

export const getDepositforReseller = async (
  dispatch,
  resellerId,
  setIsLoading,
) => {
  try {
    setIsLoading(true);
    const res = await apiLink.get(`/deposit/reseller/collector/${resellerId}`);
    dispatch(getDepositSuccess(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const depositAcceptReject = async (
  dispatch,
  status,
  id,
  setAccLoading,
) => {
  // console.log(status, id);
  setAccLoading(true);
  try {
    const res = await apiLink.patch(`/deposit/${id}`, { status: status });
    dispatch(updateDepositSuccess(res.data));
    setAccLoading(false);
    if (res.data.status === "accepted") {
      langMessage(
        "success",
        "ডিপোজিট গ্রহণ সফল হয়েছে",
        "Deposti Received Successfully",
      );
    } else if (res.data.status === "rejected") {
      langMessage(
        "success",
        "ডিপোজিট বাতিল সফল হয়েছে",
        "Deposit Cancellation Successfully",
      );
    }
  } catch (error) {
    toast.error(error.message);
  }
  setAccLoading(false);
};

export const getAllBills = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF1.get(
      `/reseller/bills/${resellerId}?year=${year}&month=${month}`,
    );
    dispatch(getAllBillsSuccess(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

//my deposit

export const getMyDeposit = async (dispatch) => {
  try {
    const res = await apiLink.get("/deposit");
    dispatch(getmyDepositSucces(res.data));
  } catch (error) {
    toast.error(error.message);
  }
};

//Collector Bills

export const getCollectorBill = async (dispatch) => {
  try {
    const res = await apiLink.get("/bill/monthlyBill");
    dispatch(getCollectorBills(res.data));
  } catch (error) {
    toast.error(error.message);
  }
};

//sub areas for reseller

export const getSubAreas = async (dispatch, resellerId) => {
  try {
    const res = await apiLink.get(`/reseller/subArea/${resellerId}`);
    dispatch(getSubareas(res.data));
  } catch (error) {
    console.log(error);
  }
};

export const getArea = async (dispatch, resellerId) => {
  try {
    const res = await apiLink.get(`/reseller/area/${resellerId}`);
    dispatch(FetchAreaSuccess(res.data));
  } catch (error) {
    console.log(error);
  }
};

// mikrotiks

export const getMikrotik = async (dispatch, resellerId) => {
  try {
    const res = await apiLink.get(`/reseller/mikrotik/${resellerId}`);

    dispatch(getMikrotikSuccess(res.data));
  } catch (error) {
    console.log(error);
  }
};

export const fetchpppoePackage = async (dispatch, IDs) => {
  try {
    const res = await apiLink({
      method: "GET",
      url: `/mikrotik/ppp/package/${IDs.mikrotikId}`,
    });
    dispatch(getpppoePackageSuccess(res.data));
  } catch (error) {
    toast.error(error.message);
  }
};

export const getResellerPackages = async (dispatch, resellerId) => {
  try {
    const res = await apiLink({
      method: "GET",
      url: `/reseller/package/${resellerId}`,
    });
    dispatch(getpppoePackageSuccess(res.data.packages));
  } catch (error) {
    toast.error(error.message);
  }
};

export const rechargeHistoryfuncR = async (dispatch, resellerId) => {
  try {
    const res = await apiLink.get(`/reseller/recharge/${resellerId}`);
    dispatch(getAllRechargeHistory(res.data));
  } catch (error) {
    console.log(error.response?.data.message);
  }
};

export const getMikrotikPackages = async (dispatch, ispOwnerId) => {
  try {
    const res = await apiLink.get(
      "/mikrotik/ppp/mikrotik/package/" + ispOwnerId,
    );
    dispatch(getAllMikrotikPakages(res.data));
  } catch (error) {
    console.log(error.response?.data.message);
  }
};

//static customer

export const getStaticCustomerApi = async (
  dispatch,
  reseller,
  setIsloading,
) => {
  setIsloading(true);
  try {
    const res = await apiLink.get(`/reseller/static/customer/${reseller}`);
    dispatch(getStaticCustomerSuccess(res.data));
  } catch (error) {
    console.log(error.message);
  }
  setIsloading(false);
};

// get support
export const getResellerNetFeeSupport = async (
  dispatch,
  setIsLoading,
  resellerId,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`reseller/netFee/support/${resellerId}`);
    dispatch(getResellerSupport(res.data));
  } catch (error) {
    console.log(error.response);
  }
  setIsLoading(false);
};

// post support
export const postResellerNetFeeSupport = async (
  dispatch,
  setIsLoading,
  supportData,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(
      `reseller/create/netFee-support`,
      supportData,
    );
    dispatch(addResellerSupport(res.data));
    langMessage(
      "success",
      "নেটফি সাপর্ট অ্যাড সফল হয়েছে",
      "NetFee Support Add Successfully",
    );
    document.querySelector("#resellerSupportAdd").click();
  } catch (error) {
    console.log(error.response);
  }
  setIsLoading(false);
};

//put support
export const putResellerNetFeeSupport = async (
  dispatch,
  setIsLoading,
  editSupport,
) => {
  setIsLoading(true);

  try {
    const res = await apiLink.patch(
      `reseller/netFee/support-edit/${editSupport.id}`,
      editSupport,
    );
    document.querySelector("#resellerSupportEditId").click();
    dispatch(updateResellerSupport(res.data));
    langMessage(
      "success",
      "নেটফি সাপর্ট আপডেট সফল হয়েছে",
      "NetFee Support Update Successfully",
    );
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

// get reseller customer change request
export const getChangePackage = async (dispatch, resellerId, setIsLoading) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get(
      `reseller/customer/package/changes/data?resellerId=${resellerId}`,
    );
    dispatch(getResellerChangePackageRequest(res.data));
  } catch (error) {
    console.log(error.response);
  }

  setIsLoading(false);
};

//accepted package
export const acceptedChangePackage = async (dispatch, data, setIsLoading) => {
  setIsLoading(true);

  try {
    const res = await apiLink.patch(`reseller/accept/package/change`, data);
    dispatch(updateResellerChangePackageRequest(res.data));
  } catch (error) {
    console.log(error.response);
  }

  setIsLoading(false);
};

//reject package
export const rejectChangePackage = async (dispatch, data, setIsLoading) => {
  setIsLoading(true);

  try {
    const res = await apiLink.patch(`reseller/reject/package/change`, data);
    dispatch(updateResellerChangePackageRequest(res.data));
  } catch (error) {
    console.log(error.response);
  }

  setIsLoading(false);
};

//get reseller online customer payment balance
export const getOnlineBalance = async (
  resellerId,
  year,
  month,
  setOnlineBalance,
) => {
  try {
    const res = await apiLink.get(
      `reseller/customer-online-payment/${resellerId}?year=${year}&month=${month}`,
    );
    setOnlineBalance(res.data);
  } catch (error) {
    toast.error(error.response?.data.message);
  }
};

// reseller online customer payment withdraw balance
export const postOnlinePayment = async (dispatch, data, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(
      `reseller/payment/withdraw/${data?.reseller}`,
      data,
    );
    dispatch(postWithdrawBalance(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

// get reseller payment withdraw report
export const getPaymentWithdrawReport = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/payment/withdraw/${resellerId}?year=${year}&month=${month}`,
    );
    dispatch(getWithdrawBalance(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

// get reseller payment withdraw report
export const getResellerUsers = async (dispatch, resellerId, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`reseller/staffs/${resellerId}`);
    dispatch(getResellerUsersData(res.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const bandwidthPackageSubmit = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(`/reseller/bandwidth/package`, data);
    dispatch(createBandwidthPackageSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ প্যাকেজ সফলভাবে যোগ করা হয়েছে।",
      "Bandwidth package added successfully.",
    );
    setShow(false);
  } catch (error) {
    toast.error(error?.message);
  }
  setIsLoading(false);
};

export const updateBandwidthPackageSubmit = async (
  dispatch,
  packageId,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(
      `/reseller/bandwidth/package/${packageId}`,
      data,
    );
    dispatch(updatedBandwidthPackageSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ প্যাকেজ সফলভাবে আপডেট করা হয়েছে।",
      "Bandwidth package updated successfully.",
    );
    setShow(false);
  } catch (error) {
    toast.error(error?.message);
  }
  setIsLoading(false);
};

export const deleteBandwidthPackage = async (
  dispatch,
  packageId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.delete(
      `/reseller/bandwidth/package/${packageId}`,
    );
    dispatch(deleteBandwidthPackageSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ প্যাকেজ সফলভাবে মুছে ফেলা হয়েছে।",
      "Bandwidth package successfully deleted.",
    );
  } catch (error) {
    toast.error(error?.message);
  }
  setIsLoading(false);
};

export const getBandwidthPackageByISPOwner = async (
  dispatch,
  ispOwner,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/reseller/bandwidth/package/${ispOwner}`);
    dispatch(getBandwidthPackageSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const updateBandwidthResellerSubmit = async (
  dispatch,
  resellerId,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(
      `/reseller/bandwidth/reseller/${resellerId}`,
      data,
    );
    dispatch(updatedBandwidthResellerSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ রিসেলার সফলভাবে আপডেট করা হয়েছে।",
      "Bandwidth reseller updated successfully.",
    );
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const deleteBandwidthReseller = async (
  dispatch,
  resellerId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.delete(
      `/reseller/bandwidth/reseller/${resellerId}`,
    );
    dispatch(deleteBandwidthResellerSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ রিসেলার সফলভাবে মুছে ফেলা হয়েছে।",
      "Bandwidth reseller successfully deleted.",
    );
  } catch (error) {
    toast.error(error?.message);
  }
  setIsLoading(false);
};

export const bandwidthResellerSubmit = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(`/reseller/bandwidth/reseller`, data);
    dispatch(createBandwidthResellerSuccess(res.data?.data));

    langMessage(
      "success",
      "ব্যান্ডউইথ রিসেলার সফলভাবে যোগ করা হয়েছে।",
      "Bandwidth reseller added successfully.",
    );
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getBandwidthResellerByISPOwner = async (
  dispatch,
  ispOwner,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/reseller/bandwidth/reseller/${ispOwner}`);
    dispatch(getBandwidthResellerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const bandwidthSaleInvoice = async (dispatch, data, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(`/reseller/bandwidth/invoice`, data);

    dispatch(createBandwidthSaleInvoiceSuccess(res.data?.data));
    langMessage(
      "success",
      "রিসেলার ব্যান্ডউইথ ইনভয়েস সফলভাবে তৈরি করা হয়েছে।",
      "Reseller bandwidth invoice created successfully.",
    );
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const updateBandwidthSaleInvoice = async (
  dispatch,
  invoiceId,
  data,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(
      `/reseller/bandwidth/invoice/${invoiceId}`,
      data,
    );
    dispatch(updatedBandwidthSaleInvoiceSuccess(res.data?.data));

    langMessage(
      "success",
      "রিসেলার ব্যান্ডউইথ ইনভয়েস আপডেট সফল হয়েছে।",
      "Reseller bandwidth invoice update successful.",
    );
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getBandwidthInvoiceByReseller = async (
  dispatch,
  reseller,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/reseller/bandwidth/invoice/${reseller}`);
    dispatch(getBandwidthSaleInvoiceSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const resellerBandwidthBillCollected = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(
      `/reseller/bandwidth/invoice/collection`,
      data,
    );

    dispatch(createBandwidthBillReportSuccess(res.data?.data));
    langMessage(
      "success",
      "রিসেলার ব্যান্ডউইথ বিল সফলভাবে সংগ্রহ করা হয়েছে।",
      "Reseller bandwidth bill collected successfully.",
    );
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const resellerBandwidthBillReport = async (
  dispatch,
  ispOwner,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `/reseller/bandwidth/bill/collection/${ispOwner}`,
    );

    dispatch(getBandwidthBillReportSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const createResellerSupportNumber = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post(`/reseller/customer/support/numbers`, data);

    setShow(false);
    langMessage(
      "success",
      "রিসেলার সাপোর্ট নম্বর তৈরি সফল হয়েছে।",
      "Reseller support number creation was successful.",
    );
    dispatch(createResellerSupportNumbersSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getResellerSupportNumber = async (
  dispatch,
  resellerId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `/reseller/customer/support/numbers/${resellerId}`,
    );

    dispatch(getResellerSupportNumbersSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const updateResellerSupportNumber = async (
  dispatch,
  resellerId,
  supportId,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(
      `/reseller/customer/support/numbers/${resellerId}/${supportId}`,
      data,
    );

    setShow(false);
    langMessage(
      "success",
      "রিসেলার সাপোর্ট নম্বর আপডেট সফল হয়েছে।",
      "Reseller support number update successful.",
    );
    dispatch(updatedResellerSupportNumbersSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const deleteResellerSupportNumber = async (
  dispatch,
  resellerId,
  supportId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    await apiLink.delete(
      `/reseller/customer/support/numbers/${resellerId}/${supportId}`,
    );

    langMessage(
      "success",
      "রিসেলার সাপোর্ট নম্বর মুছে ফেলা সফল হয়েছে।",
      "Reseller support number deletion was successful.",
    );
    dispatch(deleteResellerSupportNumbersSuccess(supportId));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getResellerActiveCustomer = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/${resellerId}/active/customer?month=${month}&year=${year}`,
    );

    dispatch(getActiveCustomerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

export const getResellerInactiveCustomer = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/${resellerId}/inactive/customer?month=${month}&year=${year}`,
    );

    dispatch(getInactiveCustomerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

export const getResellerExpiredCustomer = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/${resellerId}/expired/customer?month=${month}&year=${year}`,
    );

    dispatch(getExpiredCustomerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

export const getResellerPaidCustomer = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/${resellerId}/paid/customer?month=${month}&year=${year}`,
    );

    dispatch(getPaidCustomerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};

export const getResellerUnpaidCustomer = async (
  dispatch,
  resellerId,
  year,
  month,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `reseller/${resellerId}/unpaid/customer?month=${month}&year=${year}`,
    );

    dispatch(getUnpaidCustomerSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
  }

  setIsLoading(false);
};
